// Measures card text with the real fonts, so automatic layout knows each card's true width.
import type { Measure } from './graph';

const FONTS: Record<Parameters<Measure>[1], string> = {
  title: '600 13px "Inter Variable"',
  base: '400 12px "Inter Variable"',
  name: '400 13px "Inter Variable"',
  type: '400 11.5px "JetBrains Mono Variable"',
  section: '600 12px "Inter Variable"',
  tag: '600 10px "Inter Variable"',
};

let context: CanvasRenderingContext2D | null = null;
const cache = new Map<string, number>();

export const measureText: Measure = (text, font) => {
  const key = `${font}|${text}`;
  const cached = cache.get(key);
  if (cached !== undefined) return cached;
  context ??= document.createElement('canvas').getContext('2d');
  if (!context) return text.length * 7.4;
  context.font = FONTS[font];
  const width = context.measureText(text).width * (font === 'tag' ? 1.04 : 1);
  cache.set(key, width);
  return width;
};

let ready: Promise<void> | null = null;

/**
 * Resolves when the card fonts are loaded (measurements before that would use fallback fonts).
 * Called lazily: until the stylesheet is applied, the @font-face rules do not exist yet and
 * document.fonts.load() resolves with nothing, so it retries for up to two seconds.
 */
export function cardFontsReady(): Promise<void> {
  ready ??= (async () => {
    for (let attempt = 0; attempt < 20; attempt++) {
      const faces = await Promise.all(Object.values(FONTS).map((f) => document.fonts.load(f)));
      if (faces.every((list) => list.length > 0)) break;
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    cache.clear();
  })().catch(() => undefined);
  return ready;
}
